import { render, staticRenderFns } from "./RankTabData.vue?vue&type=template&id=0e367f63&scoped=true"
import script from "./RankTabData.vue?vue&type=script&lang=js"
export * from "./RankTabData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e367f63",
  null
  
)

export default component.exports